export default __webpack_public_path__ + "static/media/fcv-service-cost.05186796.svg";